import { isHTMLContentEmpty } from "helpers/common";
import { array, number, object, string, date, boolean } from "yup";

const peerReferenceSchema = object().shape({
    start_date: date()
        .nullable()
        .required("Start date is required"),

    weeks_volunteered: number()
        .typeError("Weeks volunteered must be a number")
        .required("Weeks volunteered is required")
        .min(0, "Weeks cannot be negative")
        .max(520, "Weeks looks too high"),

    hours_volunteered: number()
        .typeError("Hours volunteered must be a number")
        .required("Hours volunteered is required")
        .min(0, "Hours cannot be negative")
        .max(10000, "Hours looks too high"),

    about: object().shape({
        text: string()
            .test(
                "is-not-empty",
                "About volunteer text is required",
                (value) => !isHTMLContentEmpty(value)
            )
            .required("About volunteer is required"),
        // attachments: array()
        //     .min(1, "At least one attachment is required")
        //     .required("About attachment is required")
    }),

    about_chatter: object().shape({
        text: string()
            .test(
                "is-not-empty",
                "About chatter  text is required",
                (value) => !isHTMLContentEmpty(value)
            )
            .required("About chatter is required"),
        // attachments: array()
        //     .min(1, "At least one attachment is required")
        //     .required("About chatter attachment is required")
    }),

    save_for_later: boolean().nullable(),


});

export default peerReferenceSchema;
